export enum ContributionSummaryShares {
  Fqde = 'fqde',
  Association = 'association',
  Total = 'total',
}
